import type { FC } from "react";
import Button from "@mui/material/Button";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { useTranslation } from "@privacy/translations";
import { PlusIcon, SparklesIcon } from "../../shared/icons";
import { usePrivacyNavigate } from "../../shared/usePrivacyNavigate";
import type { RecordKind } from "./assistantConversationMeta";
import { recordCountKey } from "./assistantConversationMeta";

type AssistantConversationHeaderProps = { title?: string | null; recordKinds?: Array<RecordKind> };

export const AssistantConversationHeader: FC<AssistantConversationHeaderProps> = ({ title, recordKinds = [] }) => {
  const { t } = useTranslation();
  const { navigate, paths } = usePrivacyNavigate();

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        gap: 1.5,
        px: 3,
        py: 2,
        borderBottom: theme => `1px solid ${theme.palette.divider}`,
      }}
    >
      <SparklesIcon size={18} />
      <Typography noWrap sx={{ fontWeight: 600, fontSize: theme => theme.typography.pxToRem(16), flexShrink: 0 }}>
        {t("Assistant.Title")}
      </Typography>
      {title && (
        <Typography
          noWrap
          sx={{
            fontSize: theme => theme.typography.pxToRem(16),
            minWidth: 0,
            color: theme => theme.palette.text.secondary,
          }}
        >
          {title}
        </Typography>
      )}
      {recordKinds.map(kind => (
        <Chip key={kind.formType} size="small" label={t(recordCountKey(kind), { count: String(kind.count) })} />
      ))}
      <Box sx={{ flex: 1 }} />
      <Button
        size="small"
        variant="outlined"
        startIcon={<PlusIcon size={14} />}
        onClick={() => navigate(paths.assistantNew())}
        sx={{ flexShrink: 0 }}
      >
        {t("Assistant.History.NewChat")}
      </Button>
    </Stack>
  );
};
